// extracted by mini-css-extract-plugin
export var container = "_79-0";
export var containerTopRight = "_79-1";